export default __webpack_public_path__ + "static/media/chevron-down.f871fc4a.svg";